import React, {Component} from 'react'
import PropTypes from 'prop-types'
import showDateTime from "../../../../shared/ShowDateTime"
import LazyLoad from 'react-lazyload'


class UploadTime extends Component {
    render() {
        const {uploadedAt} = this.props

        return (
            <td className='UploadTime'>
                <LazyLoad>

                    {showDateTime(uploadedAt)}
                </LazyLoad>
            </td>
        )
    }
}

UploadTime.defaultProps = {
    uploadedAt: '',
}

UploadTime.propTypes = {
    uploadedAt: PropTypes.string,
}

export default UploadTime
